/**
 * Card nav arrows — Phase 5.2 (rebuilt 2026-04-26)
 *
 * Server-rendered prev/next buttons live as siblings of the
 * .product-card-scroll-link inside .media (see card-product.liquid).
 * This script only attaches click handlers — no DOM injection —
 * so chevrons are always rendered with the correct directional
 * paths and there's no SSR/CSR mismatch.
 *
 * Native horizontal swipe is handled by CSS scroll-snap on
 * .product-card-scroll (theme.css.liquid:3176 + scrollbar-hide
 * rules in card-nav-arrows.css). Click handlers complement that
 * with programmatic scrollBy of one image-width per click.
 */

(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const edgeBound = new WeakSet();

  function init() {
    document.querySelectorAll('.card-nav-arrow').forEach(setupArrow);
  }

  function setupArrow(button) {
    if (button.dataset.bound === '1') return;
    button.dataset.bound = '1';

    const media = button.closest('.media');
    if (!media) return;
    const scroll = media.querySelector('.product-card-scroll');
    if (!scroll) return;

    const direction = button.classList.contains('card-nav-arrow--prev') ? -1 : 1;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scroll.scrollBy({
        left: direction * scroll.clientWidth,
        behavior: 'smooth',
      });
    });

    setupEdgeState(media, scroll);
  }

  function setupEdgeState(media, scroll) {
    if (edgeBound.has(scroll)) return;
    edgeBound.add(scroll);

    const prev = media.querySelector('.card-nav-arrow--prev');
    const next = media.querySelector('.card-nav-arrow--next');
    if (!prev || !next) return;

    let timeout;
    function update() {
      const max = scroll.scrollWidth - scroll.clientWidth;
      prev.setAttribute('aria-disabled', scroll.scrollLeft <= 1 ? 'true' : 'false');
      next.setAttribute('aria-disabled', scroll.scrollLeft >= max - 1 ? 'true' : 'false');
    }

    scroll.addEventListener('scroll', function () {
      clearTimeout(timeout);
      timeout = setTimeout(update, 60);
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
